import { animate, animateChild, group, query, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, ElementRef, HostListener, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ValuesType } from 'utility-types';
import { coverAnimation, modalAnimation } from '../animations';
import { ModalInstanceService } from '../form-core/modal/modal-instance.service';
import { ModalID } from '../form-json.types';

@Component({
  selector: 'div[data-component-type=modal]',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [coverAnimation, modalAnimation]
})
export class ModalComponent implements OnInit, AfterViewInit {

  @Input() title: string | undefined
  @Input() content: any
  @ViewChild('modal') modalEl!: ElementRef<HTMLDivElement>
  @ViewChild('wrapper') wrapperEl!: ElementRef<HTMLDivElement>

  iconInWrapper: boolean = true

  constructor(private modalInstance: ModalInstanceService, private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  @HostListener('mousedown') destroyInstance() {
    this.modalInstance.destroy()
  }

  stopBehaviour(event: MouseEvent) {
    event.stopPropagation()
    event.preventDefault()
  }

  ngAfterViewInit(): void {
    if (this.wrapperEl.nativeElement.offsetHeight - this.modalEl.nativeElement.offsetHeight === 90) {
      setTimeout(() => {
        this.iconInWrapper = false
        this.cd.markForCheck()
      }, 0);
    }
  }

}

export interface ModalOptions {
  type: ValuesType<Omit<ModalID, 'id'>>
  title?: string,
  content?: any,
  'sub-title'?: string
}